const initialState = {
  activeProject: undefined,
  activeTab: 'By Cluster',
  tabRequested: 'By Cluster',
  tabChangeRequested: false,
  isFetchingProjects: true,
  isLeaving: false,
  tabChangeReady: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'PROJECTS:REQUEST': {
      return {
        ...state,
        isFetchingProjects: true,
      };
    }
    case 'PROJECTS:SUCCESS': {
      return {
        ...state,
        isFetchingProjects: false,
      };
    }
    case 'PROJECT:SET_ACTIVE': {
      return {
        ...state,
        activeProject: action.payload.project,
      };
    }
    case 'TAB:ASKED_TO_LEAVE': {
      return {
        ...state,
        tabRequested: action.payload.tab,
        tabChangeRequested: true,
        tabChangeReady: false,
      };
    }
    case 'TAB:IS_READY_TO_LEAVE': {
      return {
        ...state,
        tabChangeReady: action.payload.isReady,
        activeTab: state.tabRequested,
        tabChangeRequested: false,
      };
    }
    default: {
      return state;
    }
  }
};

export const getActiveProject = state => state.activeProject;
export const getActiveTab = state => state.activeTab;
export const getIsFetchingProjects = state => state.isFetchingProjects;
export const tabChangeRequested = state => state.tabChangeRequested;
export const tabChangeReady = state => state.tabChangeReady;
export const getRequestedTab = state => state.tabRequested;



// WEBPACK FOOTER //
// ./src/reducers/ui.js